import claims from './claims';
import admin from './admin';
import document from './document';
import billing from './billing';
import glass from './glass';

export default [
  claims,
  admin,
  document,
  billing,
  glass
];
